import { Block, Inline } from '@contentful/rich-text-types';
import { Next, NodeRenderer } from '@contentful/rich-text-html-renderer';

export const getEmbeddedAssetHtml = ((_node: Block | Inline, _next: Next) =>
  'Embedded Asset is not supported by this feature yet.') as NodeRenderer;
